import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableClinicalProductCategoryFragment = { readonly __typename?: 'SyncableClinicalProductCategory', readonly id: string, readonly title: { readonly __typename?: 'ClinicalProductCategoryTitle', readonly en: string }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncClinicalProductCategoryPullQueryVariables = Types.Exact<{
  input: Types.PullClinicalProductCategoryInput;
}>;


export type SyncClinicalProductCategoryPullQuery = { readonly __typename?: 'Query', readonly pullClinicalProductCategory: { readonly __typename?: 'PullClinicalProductCategoryResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableClinicalProductCategory', readonly id: string, readonly title: { readonly __typename?: 'ClinicalProductCategoryTitle', readonly en: string }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableClinicalProductCategoryFragmentDoc = gql`
    fragment WholeSyncableClinicalProductCategory on SyncableClinicalProductCategory {
  id
  title {
    en
  }
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncClinicalProductCategoryPullDocument = gql`
    query SyncClinicalProductCategoryPull($input: PullClinicalProductCategoryInput!) {
  pullClinicalProductCategory(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableClinicalProductCategory
    }
  }
}
    ${WholeSyncableClinicalProductCategoryFragmentDoc}`;

/**
 * __useSyncClinicalProductCategoryPullQuery__
 *
 * To run a query within a React component, call `useSyncClinicalProductCategoryPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncClinicalProductCategoryPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncClinicalProductCategoryPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncClinicalProductCategoryPullQuery(baseOptions: Apollo.QueryHookOptions<SyncClinicalProductCategoryPullQuery, SyncClinicalProductCategoryPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncClinicalProductCategoryPullQuery, SyncClinicalProductCategoryPullQueryVariables>(SyncClinicalProductCategoryPullDocument, options);
      }
export function useSyncClinicalProductCategoryPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncClinicalProductCategoryPullQuery, SyncClinicalProductCategoryPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncClinicalProductCategoryPullQuery, SyncClinicalProductCategoryPullQueryVariables>(SyncClinicalProductCategoryPullDocument, options);
        }
export type SyncClinicalProductCategoryPullQueryHookResult = ReturnType<typeof useSyncClinicalProductCategoryPullQuery>;
export type SyncClinicalProductCategoryPullLazyQueryHookResult = ReturnType<typeof useSyncClinicalProductCategoryPullLazyQuery>;
export type SyncClinicalProductCategoryPullQueryResult = Apollo.QueryResult<SyncClinicalProductCategoryPullQuery, SyncClinicalProductCategoryPullQueryVariables>;